import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	numDeployments: {
		id: 'software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.num-deployments',
		defaultMessage:
			'{numDeployments} {numDeployments, plural, one {Deployment} other {Deployments}}',
		description:
			'Forms part of title for a dialog that shows the number of deployments that occurred on a given date. Example: 2 Deployments on 16 April',
	},
	seeMoreInfo: {
		id: 'software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.see-more-info',
		defaultMessage:
			'A clickable label that reveals additional, more detailed information about a deployment',
		description:
			'Label on clickable chevron icon that a user can click to display more information about a deployment ',
	},
	showMoreInfo: {
		id: 'software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.show-more-info',
		defaultMessage: 'Show more information',
		description: 'Button text to pop up deployments modal showing all deployments for an issue',
	},
	deployment: {
		id: 'software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.deployment',
		defaultMessage: 'Deployment',
		description: 'Title for section of a dialog that links to url of deployment',
	},
	environment: {
		id: 'software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.environment',
		defaultMessage: 'Environment',
		description:
			'Title for section of a dialog that displays information about the environment a deployment was deployed to',
	},
	pipeline: {
		id: 'software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.pipeline',
		defaultMessage: 'Pipeline',
		description: 'Title for section of a dialog that links to url of the deployments environment',
	},
	updated: {
		id: 'software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.updated',
		defaultMessage: 'Updated',
		description: 'Title for section of a dialog that displays how long ago the deployment was.',
	},
});
